module.exports = __webpack_public_path__ + "static/media/rain_light.3e96dcd2.jpg";